// generated by tools/get-version.mts - edits will be overwritten
export const version = "15.0.11";
